import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";


export default function Footer() {
    return (
        <React.Fragment>
            <div className="container-fluid text-light mt-5 wow fadeInUp" data-wow-delay="0.1s" style={{backgroundColor:"#0B1B3A"}}>
            <div className="container">
                <div className="row gx-5">
                    <div className="col-lg-4 col-md-6 footer-about">
                        <div className="d-flex flex-column align-items-center justify-content-center text-center h-100 bg-primary p-4">
                            <a href="index.html" className="navbar-brand">
                                <h1 className="m-0 text-white"><i className="fa fa-book me-2"></i>Dgbook</h1>
                            </a>
                            <p className="mt-3 mb-4" style={{fontStyle:"italic"}}>DGBOOK, Librairie numérique d’économie et de gestion </p>
                          {/**   <form action="">
                                <div className="input-group">
                                    <input type="text" className="form-control border-white p-3" placeholder="Your Email" />
                                    <button className="btn btn-dark">Envoyer</button>
                                </div>
                            </form>*/}
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-6">
                        <div className="row gx-5">
                            <div className="col-lg-4 col-md-12 pt-5 mb-5">
                                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                                    <h3 className="text-light mb-0">Contact</h3>
                                </div>
                                <div className="d-flex mb-2">
                                    <i className="bi bi-geo-alt text-primary me-2"></i>
                                    <p className="mb-0">Porto-Novo (BENIN)</p>
                                </div>
                                <div className="d-flex mb-2">
                                    <i className="bi bi-envelope-open text-primary me-2"></i>
                                    <p className="mb-0">sales@dgbook.africa</p>
                                </div>
                                <div className="d-flex mb-2">
                                    <i className="bi bi-telephone text-primary me-2"></i>
                                    <p className="mb-0">+229 69 61 99 99</p>
                                </div>
                               
                            </div>
                            <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                                    <h3 className="text-light mb-0">Liens utiles</h3>
                                </div>
                                <div className="link-animated d-flex flex-column justify-content-start">
                                <Link  className="text-light mb-2" to={myroutes.homepage}><i className="bi bi-arrow-right text-primary me-2"></i>Accueil</Link>
                                    <Link  className="text-light mb-2" to={myroutes.catalogue}><i className="bi bi-arrow-right text-primary me-2"></i>Catalogue</Link>
                                    <Link  className="text-light mb-2" to={myroutes.comment_ca_marche}><i className="bi bi-arrow-right text-primary me-2"></i>Comment ça marche ?</Link>
                                    <Link  className="text-light mb-2" to={myroutes.contact}><i className="bi bi-arrow-right text-primary me-2"></i>Contact</Link>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                                <div className="">
                                    <h3 className="text-light mb-0" style={{fontSize:"16px", fontWeight:"300", marginTop:"40px" }}>Veuillez nous contacter à travers les réseaux suivants </h3>
                                </div>
                                <div className="d-flex mt-4">
                                    <a className="btn btn-primary btn-square me-2" href="#"><i className="fab fa-twitter fw-normal"></i></a>
                                    <a className="btn btn-primary btn-square me-2" href="#"><i className="fab fa-facebook-f fw-normal"></i></a>
                                    <a className="btn btn-primary btn-square me-2" href="#"><i className="fab fa-linkedin-in fw-normal"></i></a>
                                    <a className="btn btn-primary btn-square" href="#"><i className="fab fa-instagram fw-normal"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container-fluid text-white" style={{background : "#061429"}}>
            <div className="container text-center">
                <div className="row justify-content-end">
                    <div className="col-lg-8 col-md-6">
                        <div className="d-flex align-items-center justify-content-center" style={{height: "75px" }}>
                            <p className="mb-0">&copy; <a className="text-white-footer " href="#">DGBOOK</a>.Tous droits réservés. 
                            
                            Designed by <a className="text-white-footer " href="https://digiweb.bj">Digiweb</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </React.Fragment>
    )
}